module.exports = __webpack_public_path__ + "img/bdl.82364d5e.png";